'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    $(document).on('click', '[data-preview-detail]', function (e) {
        e.preventDefault();
        var $this = $(this);

        $this.addClass('btn--pending');

        openModal(this);
    });

    function openModal(selector) {
        var productId = $(selector).attr('data-preview-detail');
        if (productId === undefined) return;

        $('#preview-detail-modal .modal-content').load((0, _urls2.default)('previewDetail', { id: productId }), function (result) {
            $('#preview-detail-modal').modal('show');

            (0, _lazyImage2.default)();

            $("#preview-detail-modal").on("hidden.bs.modal", function () {
                $('.modal-content', this).empty();
            });

            $('.btn--pending').removeClass('btn--pending');
        });
    }
};

var _urls = require('../urls');

var _urls2 = _interopRequireDefault(_urls);

var _lazyImage = require('linksoft/initializers/lazy-image');

var _lazyImage2 = _interopRequireDefault(_lazyImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/productPreview.js
// module id = 1186
// module chunks = 0